var pad1Tb = {
  "paddingTop": "0.625rem !important",
  "paddingBottom": "0.625rem !important"
};

export { pad1Tb };
